//Start report importing
import ValorizedPrint from './Inventory/ValorizedPrint'
import ProductProductionPrint from './Inventory/ProductProductionPrint'
import InventoryGatherPrint from './Inventory/InventoryGatherPrint'
import PendingOrdersPrint from './ClientDocument/PendingOrdersPrint'
import PendingProductOrdersPrint from './ClientDocument/PendingProductOrdersPrint'
import InvoiceByDatePrint from './Invoice/InvoiceByDatePrint'
import InvoiceByClientPrint from './Invoice/InvoiceByClientPrint'
import InvoiceByProductPrint from './Invoice/InvoiceByProductPrint'
import PendingInvoicePrint from './Invoice/PendingInvoicePrint'
import PendingPurchasePrint from './Purchase/PendingPurchasePrint'
import PurchaseByDatePrint from './Purchase/PurchaseByDatePrint'
import PurchaseByProviderPrint from './Purchase/PurchaseByProviderPrint'
import PurchaseByProductPrint from './Purchase/PurchaseByProductPrint'
import CashByDatePrint from './Cash/CashByDatePrint'

/////////////// REPORT DATA ///////////////////
const reportData = {
    inventory: [
        {
            title: "Valorizado de Inventario", //ok
            component: ValorizedPrint,
            endpoint: 'inventory/report-valorized'
        },
        {
            title: "Informe de produccion", //ok
            component: ProductProductionPrint,
            endpoint: 'inventory/report-production'
        },
        {
            title: "Toma de Inventario", //ok
            component: InventoryGatherPrint,
            endpoint: 'inventory/report-inventory-gather'
        },
    ],
    sales: [
        {
            title: "Ordenes pendientes por facturar", //ok
            component: PendingOrdersPrint,
            endpoint: 'client-document/pending/'
        },
        {
            title: "Productos pendientes por facturar", //ok
            component: PendingProductOrdersPrint,
            endpoint: 'client-document/pending/'
        },
        {
            title: "Facturas por cobrar", //ok
            component: PendingInvoicePrint,
            endpoint: 'invoice/pending/'
        },
        {
            title: "Facturacion entre fechas", //ok
            component: InvoiceByDatePrint,
            endpoint: 'invoice/by-date/'
        },
        {
            title: "Facturacion por cliente", //ok
            component: InvoiceByClientPrint,
            endpoint: 'invoice/by-client/'
        },
        {
            title: "Ventas por producto", //ok
            component: InvoiceByProductPrint,
            endpoint: 'invoice/by-product/'
        },
        {
            title: "Ventas por producto 2", //ok
            component: "",
            source: "Jasper",
            endpoint: 'product/report'
        },

    ],
    purchases: [
        {
            title: "Cuentas por pagar", //ok
            component: PendingPurchasePrint,
            endpoint: 'purchase/pending/'
        },
        {
            title: "Compras entre fechas", //ok
            component: PurchaseByDatePrint,
            endpoint: 'purchase/by-date/'
        },
        {
            title: "Compras por Proveedor", //ok
            component: PurchaseByProviderPrint,
            endpoint: 'purchase/by-provider/'
        },
        {
            title: "Compras por producto", //ok
            component: PurchaseByProductPrint,
            endpoint: 'purchase/by-product/'
        },
    ],
    cash: [
        {
            title: "Caja entre fechas", //ok
            component: CashByDatePrint,
            endpoint: 'cash/by-date/'
        },
        {
            title: "Caja Auxiliar entre fechas", //ok
            component: "",
            source: "Jasper",
            endpoint: 'cash-aux/by-date/'
        }
    ],
    payroll: [
        {
            title: "Nomina entre fechas", //ok
            component: "",
            source: "Jasper",
            endpoint: 'payroll/by-date'
        },
    ]


}

export default reportData